export function getListViewToggleRef( state ) {
	return state.listViewToggleRef;
}
